import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Heading from "../ui/Heading";
import { Link } from "react-router-dom";

const DesignDiamondRing = () => {
  const settings = {
    customPaging: function (i) {
      return <a className="dots11">{i + 1}</a>;
    },
    dots: true,
    dotsClass: "slick-dots slick-thumb",
    infinite: true,
    arrows: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  
  return (
    <section className="RingBuilderHome design-diamond-ring-section section-space">
      <Container fluid className="custom-container">
        <Row>
          <Col lg={6} md={7} xs={12}>
            <div className="textBox">
              <Heading className="text-start p-0">
                <h2>Create your Own Diamond Ring</h2>
                <p className="mb-1">Select a setting and choose a diamond to create your own diamond engagement ring.</p>
                <p className="pb-1">Need help? We're always here.</p>
                
                <div className="content mt-4">
                  <Link to="/ringsettings" className="btn outline-base-btn small mr-3">Start with a setting</Link>
                  <Link to="/diamonds" className="btn outline-base-btn small">Start with a diamond</Link>
                </div>
              </Heading>
            </div>
          </Col>
          <Col lg={6} md={5} xs={12}>
            <div class="wistia_responsive_padding">
              
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DesignDiamondRing;